<template>
  <div>
    <new-reward-modal :title="newRewardData.title" :button-options="newRewardData.options">
      {{ newRewardData.text }}
    </new-reward-modal>
    <b-button
      @click="showNewRewardModal"
      pill
      class="bg-main border-0 font-weight-bolder float-button-right rounded-circle p-1"
    >
      <i class="material-icons big-icon font-weight-bolder align-middle">
        add
      </i>
    </b-button>
  </div>
</template>

<script>
import newRewardModal from '@/gamification/components/modal/ModalNewReward';
export default {
  components: {
    newRewardModal,
  },
  data: () => {
    return {
      newRewardData: {
        title: 'New Reward',
        text: 'How do you want to create it?',
        options: [],
      },
    };
  },
  methods: {
    showNewRewardModal() {
      this.newRewardData.options = [
        {
          text: 'Create my own reward',
          action: () => {
            this.$router.push('new-reward');
          },
        },
        {
          text: 'See bank reward idea',
          action: () => {
            this.$router.push('/rewards-bank');
          },
        },
      ];
      this.$bvModal.show('ModalNewReward');
    },
  },
};
</script>

<style></style>

